// Components==============
import ReflectionIcon from 'components/UI/ReflectionIcon/ReflectionIcon';
import RootReflectionModal from 'components/UI/RootReflectionModal/RootReflectionModal';
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import React, { useContext } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import { GlobalRootPersonContext } from 'utilities/GlobalContext/GlobalRootPerson';
import { sortOnName } from 'utilities/sortOnName';
import '../StudentOverview.module.scss';
// =========================

export default function People() {
  const people = useRedux((state) =>
    state.people?.entities.allIds.map((id) => state.people?.entities.byId[id])
  );

  const { setRootPersonModal } = useContext(GlobalRootPersonContext);

  return (
    <>
      <motion.div {...framerFade} styleName="wrapper">
        {sortOnName(people)?.map(
          (person) =>
            !!person && (
              <ReflectionIcon
                name={person.name}
                image={`/storage/${person.image}`}
                onClick={() => setRootPersonModal(person)}
              />
            )
        )}
      </motion.div>
      <RootReflectionModal type="person" />
    </>
  );
}
